export default __webpack_public_path__ + "static/media/LinkedIn.76ab8095.svg";